import { render, staticRenderFns } from "./AssetsManaging.vue?vue&type=template&id=779423ea&"
import script from "./AssetsManaging.vue?vue&type=script&lang=js&"
export * from "./AssetsManaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports